import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../config/constants";
import { parseSecondsToSecondsMinutesHours } from "../../../config/functions";
import { getSessionsWithSomeHitOrError, activityIds, islandId, capsuleIds } from "../functions";
import { GetProtocolData } from "../sections/getProtocolData";
// Components
import { IndicatorDiv, InfoText } from "./styles";
import Loader from "../../loader";
import Axios from "../../../config/axios";
import PatientNavigation from "../../patientNavigation";
import MenuNavigation from "../sections/menuNavigation";
import Title from "../../title";
import ActivitiesHeader from "./sections/activitiesHeader";
import ProtocolData from "./sections/protocolData";

const Activities = () => {
  const [sessions, setSessions] = useState([]);
  // Loaders
  const [isLoadingSessions, setIsLoadingSessions] = useState(true);

  const { patientId } = useParams();
  const [t] = useTranslation("global");

  // Fetching sessions
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/icu/get-sessions/${patientId}`)
      .then(({ data }) => {
        const sessionsWithSomeHitOrError = getSessionsWithSomeHitOrError(data);
        setSessions(sessionsWithSomeHitOrError);
        setIsLoadingSessions(false);
      })
      .catch((error) => {
        console.log("Get sessions: ", error);
      });

    return () => {
      setSessions([]);
      setIsLoadingSessions(true);
    };
  }, [patientId]);

  const renderProtocolData = (title, protocolIds) => {
    return (
      <>
        <ActivitiesHeader title={title} />
        {protocolIds.map((protocolId) => {
          const { img, name } = GetProtocolData(protocolId);
          const protocolSessions = sessions.filter((protocol) => protocol.PROTOCOL_ID === protocolId);
          const sessionsNumber = protocolSessions.length;
          const accumulatedSeconds = protocolSessions.reduce(
            (sum, session) => sum + parseFloat(session["sessionDuration(seconds)"] ? session["sessionDuration(seconds)"] : 0),
            0
          );
          const averageSeconds = accumulatedSeconds / sessionsNumber;

          return (
            <ProtocolData
              key={protocolId}
              protocolId={protocolId}
              protocolImg={img}
              protocolName={t(`protocols_${name}`)}
              protocolVideo={t(`protocols_${name}Video`)}
              protocolDescription={t(`protocols_${name}Description`)}
              averageTime={Boolean(sessionsNumber) ? parseSecondsToSecondsMinutesHours(averageSeconds) : "-"}
              accumulatedTime={Boolean(sessionsNumber) ? parseSecondsToSecondsMinutesHours(accumulatedSeconds) : "-"}
              sessionsNumber={sessionsNumber}
            />
          );
        })}
      </>
    );
  };

  return (
    <>
      {isLoadingSessions ? (
        <Loader />
      ) : (
        <>
          <PatientNavigation patientId={patientId} section={"icu"} />
          <MenuNavigation />
          <Title title={`${t("applications_icu")} / ${t("reports").toUpperCase()}`} marginBottom="10px" />
          <IndicatorDiv>
            <InfoText>{t("prescriptions_reportsIndication")}</InfoText>
          </IndicatorDiv>
          {renderProtocolData("activities", activityIds)}
          {renderProtocolData("island", islandId)}
          {renderProtocolData("capsules", capsuleIds)}
        </>
      )}
    </>
  );
};

export default Activities;
